import { TicketListItemDto } from "@megaron/support-contracts";

import { SupportTicketMobileCard } from "./SupportTicketMobileCard";

type Props = {
  items: TicketListItemDto[];
  basePath: string;
  className?: string;
};

export const SupportTicketsMobileList: React.FC<Props> = ({ items, basePath, className }) => {
  return (
    <div
      className={className}
      css={{ display: "flex", flexDirection: "column", gap: "0.625rem", width: "100%", marginBottom: "1rem" }}
    >
      {items.map((item) => (
        <SupportTicketMobileCard key={item.id} item={item} basePath={basePath} />
      ))}
    </div>
  );
};
